// JDG Stearns & Foster Collection JS
// Shared by Estate + Lux Estate pages
// Default model is read from data-default-model on #jdg-sf-container
(function() {

  var PRODUCTS = {
    estate: {
      title:    'Estate®',
      handle:   'stearns-foster-estate-collection-mattress',
      priceFrom: 1799,
      variants: {
        'Twin XL|Firm':                  { id: '53217075691631', price: 1799 },
        'Twin XL|Medium':                { id: '53217075724399', price: 1799 },
        'Twin XL|Firm Pillow Top':       { id: '53217075757167', price: 2199 },
        'Twin XL|Soft Pillow Top':       { id: '53217075789935', price: 2199 },
        'Full|Firm':                     { id: '53217075822703', price: 1949 },
        'Full|Medium':                   { id: '53217075855471', price: 1949 },
        'Full|Firm Pillow Top':          { id: '53217075888239', price: 2349 },
        'Full|Soft Pillow Top':          { id: '53217075921007', price: 2349 },
        'Queen|Firm':                    { id: '53217075953775', price: 1999 },
        'Queen|Medium':                  { id: '53217075986543', price: 1999 },
        'Queen|Firm Pillow Top':         { id: '53217076019311', price: 2399 },
        'Queen|Soft Pillow Top':         { id: '53217076052079', price: 2399 },
        'King|Firm':                     { id: '53217076084847', price: 2999 },
        'King|Medium':                   { id: '53217076117615', price: 2999 },
        'King|Firm Pillow Top':          { id: '53217076150383', price: 3399 },
        'King|Soft Pillow Top':          { id: '53217076183151', price: 3399 },
        'Cal King|Firm':                 { id: '53217076215919', price: 2999 },
        'Cal King|Medium':               { id: '53217076248687', price: 2999 },
        'Cal King|Firm Pillow Top':      { id: '53217076281455', price: 3399 },
        'Cal King|Soft Pillow Top':      { id: '53217076314223', price: 3399 },
        'Split CA King|Firm':            { id: '53217076346991', price: 2999 },
        'Split CA King|Medium':          { id: '53217076379759', price: 2999 },
        'Split CA King|Firm Pillow Top': { id: '53217076412527', price: 3399 },
        'Split CA King|Soft Pillow Top': { id: '53217076445295', price: 3399 }
      },
      feels: ['Firm','Medium','Firm Pillow Top','Soft Pillow Top'],
      sizes: ['Twin XL','Full','Queen','King','Cal King','Split CA King']
    },
    luxestate: {
      title:    'Lux Estate®',
      handle:   'stearns-foster-lux-estate-collection-mattress',
      priceFrom: 2999,
      variants: {
        'Twin XL|Medium':                  { id: '53217076674671', price: 2999 },
        'Twin XL|Soft Pillow Top':         { id: '53217076707439', price: 3399 },
        'Twin XL|Medium Pillow Top':       { id: '53217076740207', price: 3699 },
        'Twin XL|Firm Pillow Top':         { id: '53217076772975', price: 3399 },
        'Queen|Medium':                    { id: '53217076805743', price: 3199 },
        'Queen|Soft Pillow Top':           { id: '53217076838511', price: 3499 },
        'Queen|Medium Pillow Top':         { id: '53217076871279', price: 3799 },
        'Queen|Firm Pillow Top':           { id: '53217076904047', price: 3499 },
        'King|Medium':                     { id: '53217076936815', price: 3799 },
        'King|Soft Pillow Top':            { id: '53217076969583', price: 4099 },
        'King|Medium Pillow Top':          { id: '53217077002351', price: 4399 },
        'King|Firm Pillow Top':            { id: '53217077035119', price: 4099 },
        'Cal King|Medium':                 { id: '53217077067887', price: 3799 },
        'Cal King|Soft Pillow Top':        { id: '53217077100655', price: 4099 },
        'Cal King|Medium Pillow Top':      { id: '53217077133423', price: 4399 },
        'Cal King|Firm Pillow Top':        { id: '53217077166191', price: 4099 },
        'Split CA King|Medium':            { id: '53217077198959', price: 3799 },
        'Split CA King|Soft Pillow Top':   { id: '53217077231727', price: 4099 },
        'Split CA King|Medium Pillow Top': { id: '53217077264495', price: 4399 },
        'Split CA King|Firm Pillow Top':   { id: '53217077297263', price: 4099 }
      },
      feels: ['Medium','Soft Pillow Top','Medium Pillow Top','Firm Pillow Top'],
      sizes: ['Twin XL','Queen','King','Cal King','Split CA King']
    }
  };

  // Read default model from container attr (set per template)
  var container = document.getElementById('jdg-sf-container');
  var currentModel = (container && container.getAttribute('data-default-model')) || 'estate';
  if (!PRODUCTS[currentModel]) currentModel = 'estate';

  var currentSize = 'Queen';
  var currentFeel = PRODUCTS[currentModel].feels.indexOf('Medium') !== -1 ? 'Medium' : PRODUCTS[currentModel].feels[0];

  function fmt(p) { return '$' + p.toLocaleString('en-US'); }

  function getVariant() {
    var pr = PRODUCTS[currentModel];
    return pr.variants[currentSize + '|' + currentFeel] || null;
  }

  function updatePrice() {
    var v  = getVariant();
    var pr = PRODUCTS[currentModel];
    var pe = document.getElementById('jdg-sf-price');
    var ne = document.getElementById('jdg-sf-price-note');
    if (!pe) return;
    pe.textContent = v ? fmt(v.price) : 'From ' + fmt(pr.priceFrom);
    ne.textContent = v ? currentSize + ' · ' + currentFeel : 'Select size & feel above';
  }

  function updateButtons() {
    var v        = getVariant();
    var pr       = PRODUCTS[currentModel];
    var viewBtn  = document.getElementById('jdg-sf-view-btn');
    var cartForm = document.getElementById('jdg-sf-cart-form');
    var vidInput = document.getElementById('jdg-sf-vid');

    if (viewBtn) {
      viewBtn.href = v ? '/products/' + pr.handle + '?variant=' + v.id : '/products/' + pr.handle;
    }
    if (cartForm && vidInput) {
      if (v && v.id) {
        cartForm.style.display = 'block';
        vidInput.value = v.id;
      } else {
        cartForm.style.display = 'none';
      }
    }
  }

  function updateRightPanel() {
    var pr = PRODUCTS[currentModel];
    var te = document.getElementById('jdg-sf-rp-title');
    if (te) te.textContent = pr.title + ' Collection';

    var fc = document.getElementById('jdg-sf-feels');
    if (fc) {
      fc.innerHTML = '';
      pr.feels.forEach(function(f, i) {
        var b = document.createElement('button');
        b.className   = 'jdg-rp-opt' + (i === 0 ? ' selected' : '');
        b.textContent = f;
        b.onclick     = function() { selectFeel(f, b); };
        fc.appendChild(b);
      });
      currentFeel = pr.feels[0];
    }

    var sc = document.getElementById('jdg-sf-sizes');
    if (sc) {
      var firstAvailable = null;
      sc.querySelectorAll('.jdg-size-btn').forEach(function(b) {
        var avail = pr.sizes.indexOf(b.dataset.size) !== -1;
        b.classList.toggle('disabled', !avail);
        b.classList.remove('selected');
        if (avail && !firstAvailable) firstAvailable = b.dataset.size;
      });
      var pick = pr.sizes.indexOf('Queen') !== -1 ? 'Queen' : firstAvailable;
      if (pick) {
        currentSize = pick;
        var pickBtn = sc.querySelector('.jdg-size-btn[data-size="' + pick + '"]');
        if (pickBtn) pickBtn.classList.add('selected');
      }
    }

    updatePrice();
    updateButtons();
  }

  function selectModel(m) {
    currentModel = m;
    document.querySelectorAll('.jdg-model-card').forEach(function(c) {
      c.classList.toggle('active', c.dataset.model === m);
    });
    document.querySelectorAll('.jdg-rp-opt[data-model]').forEach(function(o) {
      o.classList.toggle('selected', o.dataset.model === m);
    });
    updateRightPanel();
  }

  function selectSize(s, el) {
    if (el.classList.contains('disabled')) return;
    currentSize = s;
    document.querySelectorAll('.jdg-size-btn').forEach(function(b) { b.classList.remove('selected'); });
    el.classList.add('selected');
    updatePrice(); updateButtons();
  }

  function selectFeel(f, el) {
    currentFeel = f;
    document.querySelectorAll('#jdg-sf-feels .jdg-rp-opt').forEach(function(b) { b.classList.remove('selected'); });
    el.classList.add('selected');
    updatePrice(); updateButtons();
  }

  window.jdgSf = { selectModel: selectModel, selectSize: selectSize, selectFeel: selectFeel };

  document.addEventListener('DOMContentLoaded', function() { updateRightPanel(); });

})();